"use strict";

exports.__esModule = true;
exports.default = void 0;

var _utmParser = require("../modules/glitr-tracker/helpers/utmParser");

var _cookie = require("../helpers/cookie");

/* eslint-disable no-undef */

/**
 * Computes the pageview properties
` *@todo this needs to be extracted for all config-specific items and generic props
 * @param {*} user
 */
const pageView = (user, enableUtmParsingFromQueryString = true, utmParams = {}, transactionStatus = null, transactionid = null) => ({
  type: 'pageview',
  pageurl: window.location.href,
  referrer: document.referrer.length === 0 ? localStorage.getItem('previousPath') || null : document.referrer,
  subscriptionstatus: user ? 0 : null,
  previousurl: document.referrer.length === 0 ? localStorage.getItem('previousPath') || null : document.referrer,
  identityaccountid: user ? user.accountGuid || null : null,
  ...(enableUtmParsingFromQueryString ? (0, _utmParser.utmParser)(window.location.search) : (0, _utmParser.buildFromFlatObject)(utmParams)),
  transactionstatus: transactionStatus,
  transactionid
});

var _default = pageView;
exports.default = _default;